module.exports = __webpack_public_path__ + "img/chat.c1fca15d.png";